import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Drawer, Layout } from 'antd';
import { toggleCollapsedSideNav, updateWindowWidth } from 'appRedux/actions/Setting';
import PropTypes from 'prop-types';
import SidebarContent from './SidebarContent';
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE
} from '../../constants/ThemeSetting';

const { Sider } = Layout;

class Sidebar extends Component {
  componentDidMount() {
    window.addEventListener('resize', () => {
      this.props.updateWindowWidth(window.innerWidth);
    });
  }

  onToggleCollapsedNav = () => {
    this.props.toggleCollapsedSideNav(!this.props.navCollapsed);
  };

  render() {
    const {
      themeType, navCollapsed, width, navStyle, activedVaiTro
    } = this.props;

    let drawerStyle = 'gx-collapsed-sidebar';

    if (navStyle === NAV_STYLE_FIXED) {
      drawerStyle = '';
    } else if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      drawerStyle = 'gx-mini-sidebar gx-mini-custom-sidebar';
    } else if (navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      drawerStyle = 'gx-custom-sidebar';
    } else if (navStyle === NAV_STYLE_MINI_SIDEBAR) {
      drawerStyle = 'gx-mini-sidebar';
    } else if (navStyle === NAV_STYLE_DRAWER) {
      drawerStyle = 'gx-collapsed-sidebar';
    }
    if ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR
      || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) && width < TAB_SIZE) {
      drawerStyle = 'gx-collapsed-sidebar';
    }
    return (
      <Sider
        className={`gx-app-sidebar ${drawerStyle} ${themeType !== THEME_TYPE_LITE ? 'gx-layout-sider-dark' : null}`}
        collapsed={
          (width < TAB_SIZE
            ? false
            : navStyle === NAV_STYLE_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR
          )
        }
        collapsible
        theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
        trigger={null}
      >
        {
          navStyle === NAV_STYLE_DRAWER || width < TAB_SIZE
            ? (
              <Drawer
                className={`gx-drawer-sidebar ${themeType !== THEME_TYPE_LITE ? 'gx-drawer-sidebar-dark' : null}`}
                closable={false}
                onClose={this.onToggleCollapsedNav}
                placement="left"
                visible={navCollapsed}
              >
                <SidebarContent activedVaiTro={activedVaiTro} />
              </Drawer>
            )
            : <SidebarContent activedVaiTro={activedVaiTro} />
        }
      </Sider>
    );
  }
}

Sidebar.propTypes = {
  themeType: PropTypes.string.isRequired,
  navStyle: PropTypes.string.isRequired,
  updateWindowWidth: PropTypes.func.isRequired,
  toggleCollapsedSideNav: PropTypes.func.isRequired,
  navCollapsed: PropTypes.bool.isRequired,
  width: PropTypes.number.isRequired,
  activedVaiTro: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapStateToProps = ({ settings }) => {
  const {
    themeType, navStyle, navCollapsed, width, locale
  } = settings;
  return {
    themeType, navStyle, navCollapsed, width, locale
  };
};
export default connect(mapStateToProps, { toggleCollapsedSideNav, updateWindowWidth })(Sidebar);
